import { useEffect, useState } from "react";
import {
  getStockItems,
  rehydrateStockItems,
  setAllStockItems,
  subscribeStockItems,
  type StockItem,
} from "../lib/stockStore";

export function useStockItems() {
  const [items, setItems] = useState<StockItem[]>(() => getStockItems());

  useEffect(() => {
    void rehydrateStockItems();
    const unsubscribe = subscribeStockItems(() => setItems(getStockItems()));
    setItems(getStockItems());
    return unsubscribe;
  }, []);

  return { items, setAllStockItems };
}
